// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"e83b0e03b8a58dca924f","303":"c623d65c2372f57d7a10","495":"430d685666685692e08e"}[chunkId] + ".js";
};